import React from 'react'
import { connect } from 'react-redux'
import { getStatusAction } from '../../../actions/wooCommerceActions'
import Loader from '../../loaders'
import routes from '../../router/routes'
import * as queryString from 'query-string/index'
import { strings } from '../../../localization/strings'
import { appEnabled } from '../../../server/common'

class Component extends React.Component {
    queryStringData = queryString.parse(this.props.location.search)

    state = {
        success: !this.queryStringData.success
            ? 0
            : this.queryStringData.success,
    }

    getStatus = () => {
        this.props
            .getStatusAction(this.props.location.search, this.props.history)
            .then((response) => {
                if (appEnabled(response.status)) {
                    this.props.history.push(routes.orders.path)
                    this.setState({ ready: true })
                }
            })
            .catch((error) => {
                if (error.additionalData)
                    window.showDialog({ message: error.additionalData }, false)
                else window.showDialog(error, false)
            })
    }

    componentDidMount() {
        if (this.state.success === '0') {
            window.showDialog(
                { message: strings.wooCommercePermissionsDenied },
                this.getStatus
            )
        } else {
            this.getStatus()
        }
    }

    render() {
        return <Loader />
    }
}

const mapDispatchToProps = { getStatusAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
